import React from "react";
import "./statusPill.scss";

export type StatusPillVariant =
  | "success"
  | "failure"
  | "warning"
  | "neutral"
  | "info"
  | "inactive"
  | "live";

export interface StatusPillProps {
  label: string;
  variant?: StatusPillVariant;
  className?: string;
  icon?: React.ReactNode;
}

const StatusPill: React.FC<StatusPillProps> = ({
  label,
  variant = "neutral",
  className,
  icon,
}) => (
  <span
    className={`xgs-status-pill xgs-status-pill--${variant}${className ? ` ${className}` : ""}`}
  >
    {icon ? <span className="xgs-status-pill__icon">{icon}</span> : null}
    {label}
  </span>
);

export default StatusPill;
